import { useMemo } from "react";
import { Tokenizer, marked } from "marked";
import { StyleSheet } from "react-native";

import Parser from "react-native-marked/dist/module/lib/Parser.js";
import Renderer from "react-native-marked/dist/module/lib/Renderer.js";
import getStyles from "react-native-marked/dist/module/theme/styles.js";

// FIX because Stylesheet.create does not return the object itself in (very) old react-native-web
const convertStyles = (styles) => {
  let result = {};

  for (const key in styles) {
    const value = StyleSheet.flatten(styles[key]);
    result[key] = value;
  }

  return result;
}

// identical to useMarkdown() from react-native-marked
const useMarkdown = (
	value,
	options?,
) => {
	const styles = useMemo(
		() => {
		  return convertStyles(
		  getStyles(options?.styles, options?.colorScheme, options?.theme)
		  )
		},
		[options?.styles, options?.theme, options?.colorScheme],
	);

	const parser = useMemo(
		() =>
			new Parser({
				styles: styles,
				baseUrl: options?.baseUrl,
				renderer: options?.renderer ?? new Renderer(),
			}),
		[options?.renderer, options?.baseUrl, styles],
	);

	const elements = useMemo(() => {
		const tokens = marked.lexer(value, {
			gfm: true,
			tokenizer: options?.tokenizer as Tokenizer<never>,
		});
		return parser.parse(tokens);
	}, [value, parser, options?.tokenizer]);

	return elements;
};

// export default useMarkdown;

export {
  useMarkdown,
  Renderer
}

